import { onlineManager } from '@tanstack/react-query';
import onlineFilterOptionsRepositoryOfflineAdapters from '../../../../modules/offline/offlineRequestAdapters/onlineFilterOptions.repository.offlineAdapters';
import onlineFilterOptionsRepository from './onlineFilterOptions.repository';

const filterOptionsRepository = (isOfflineMode = false) =>
  isOfflineMode || !onlineManager.isOnline()
    ? onlineFilterOptionsRepositoryOfflineAdapters()
    : onlineFilterOptionsRepository();

export default filterOptionsRepository;
